import React from 'react';
import './Footer.css';

const Footer = () => {
  // Social media links - replace with your actual URLs
  const socialLinks = {
    twitter: 'https://twitter.com/idontjokelottery',
    instagram: 'https://instagram.com/idontjokelottery',
    linkedin: 'https://linkedin.com/company/idontjokelottery',
    facebook: 'https://facebook.com/idontjokelottery',
    youtube: 'https://youtube.com/@idontjokelottery'
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          {/* <img 
            src="/images/logo-small.png" 
            alt="Logo" 
            className="footer-logo"
            onError={(e) => e.target.style.display = 'none'}
          /> */}
          {/* <h3>N JOKE LOTTERY</h3> */}
          <p>Integrity • Transparency • Sucesss</p>
          <p className="nla-footer">Developed By Christian Fiakuna</p>
        </div>
        <div className="social-icons">
          <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
          <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook"></i>
          </a>
          <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
        <p>© 2026 I DON'T JOKE LOTTERY — Committed to fair play, innovation, and community development. 18+ only.</p>
        <p>Head Office: Denu Tokor, Near St. Paul's Senior High School, Volta Region, Ghana</p>
        <p>Building a legacy of trust | All prizes paid in Ghana Cedis (GH₵) | Authorized NLA Partner</p>
      </div>
    </footer>
  );
};

export default Footer;